var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found-page"},[_vm._v("\n\tThis page is not available\n")])}
var staticRenderFns = []

export { render, staticRenderFns }